import React from "react";
import { Box, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const sections = [
  {
    heading: "Information we collect",
    paragraphs: [
      "When you apply, we collect your name, email address, CV, and your agreement to this notice. You may also choose to provide a phone number, city and country or region, LinkedIn profile, current job title, skills and expertise, areas of interest, preferred work arrangement, desired job level, and reasons for joining our talent community.",
      "Providing the additional profile and preference details is optional. A phone number is optional, and we will only use it for phone or text contact about urgent career opportunities if you separately opt in on the application form.",
    ],
  },
  {
    heading: "How we use your information",
    paragraphs: [
      "Homely Buildofiy uses application information to review your experience, assess your application, match your preferences to current or future opportunities, and contact you about your application or relevant career opportunities. We do not use the career application form to subscribe you to general newsletters or unrelated marketing.",
    ],
  },
  {
    heading: "How your information is handled",
    paragraphs: [
      "When you submit the form, your application and CV are sent by email to the address configured for our careers team. The application route temporarily processes the CV in server memory to send it and does not save it to the website database. The application email and attachment may be handled by our email service provider and are accessible to personnel involved in recruitment.",
      "The searchable country, region, and city picker retrieves reference location lists from the selector library's hosted data service. That service may receive your IP address and browser request information, but the details you enter in your application are not sent when the location lists are loaded.",
    ],
  },
  {
    heading: "Retention",
    paragraphs: [
      "We will retain your application information for up to 6 months after the application is closed, so that we can manage the recruitment process and consider you for relevant opportunities. We will then delete it, unless we need to keep particular information for a longer period to meet a legal obligation or resolve a claim. You can ask us to delete your application sooner.",
    ],
  },
  {
    heading: "Your choices and requests",
    paragraphs: [
      "You can leave the optional profile and preference questions blank. You can also withdraw your phone or text contact permission, or request access to, correction of, or deletion of your application information by contacting us through the website contact form. Withdrawing permission does not affect processing that took place before withdrawal.",
    ],
  },
  {
    heading: "Contact",
    paragraphs: [
      "For questions about this notice or your application information, please use the contact form on our website and mention that your request concerns a career application.",
    ],
  },
];

const CareerPrivacyPage = () => (
  <Box sx={{ minHeight: "70vh", backgroundColor: "#f6f4ef" }}>
    <Box
      sx={{
        px: { xs: 3, md: 8 },
        py: { xs: 7, md: 10 },
        color: "#f6f4ef",
        backgroundColor: "#292720",
      }}
    >
      <Typography
        sx={{
          mb: 2,
          color: "#d5bd91",
          fontSize: "0.68rem",
          fontWeight: 600,
          letterSpacing: "0.18em",
          textTransform: "uppercase",
        }}
      >
        Careers at Homely
      </Typography>
      <Typography
        component="h1"
        sx={{
          fontFamily: 'Georgia, "Times New Roman", serif',
          fontSize: { xs: "2.5rem", md: "3.8rem" },
          fontWeight: 400,
        }}
      >
        Career Applicant Privacy Notice
      </Typography>
      <Typography sx={{ mt: 2, maxWidth: 680, color: "rgba(246,244,239,0.76)", lineHeight: 1.8 }}>
        This notice explains how Homely Buildofiy handles information submitted
        through the careers application form.
      </Typography>
    </Box>

    <Box
      component="main"
      sx={{
        display: "grid",
        gap: 3,
        maxWidth: 800,
        mx: "auto",
        px: { xs: 3, md: 5 },
        py: { xs: 5, md: 7 },
      }}
    >
      {sections.map(({ heading, paragraphs }) => (
        <Box component="section" key={heading}>
          <Typography
            component="h2"
            sx={{
              mb: 1,
              color: "#292720",
              fontFamily: 'Georgia, "Times New Roman", serif',
              fontSize: "1.45rem",
            }}
          >
            {heading}
          </Typography>
          {paragraphs.map((paragraph) => (
            <Typography
              key={paragraph}
              sx={{ mb: 1.5, color: "#716e65", lineHeight: 1.8 }}
            >
              {paragraph}
            </Typography>
          ))}
        </Box>
      ))}
      <Link
        component={RouterLink}
        to="/careers"
        sx={{
          justifySelf: "start",
          mt: 1,
          color: "#75603b",
          fontWeight: 600,
        }}
      >
        Return to careers
      </Link>
    </Box>
  </Box>
);

export default CareerPrivacyPage;
